
import { supabase } from "@/integrations/supabase/client";
import { ManualMatch, CreateManualMatchRequest } from "@/types/manualMatch";
import { handleError } from '@/utils/handleError';
import { settledRefusalOrNull } from '@/utils/errorUtils';
import { translateOutsideReact } from '@/i18n/translateOutsideReact';

export class ManualMatchApiClient {
  /**
   * Create a new manual match
   */
  static async createManualMatch(matchData: CreateManualMatchRequest): Promise<ManualMatch | null> {
    const { data, error } = await supabase.functions.invoke("manual-match-api", {
      method: "POST",
      body: { action: "createManualMatch", ...matchData },
    });

    if (error) {
      // FIN-968: a transaction that already settles another document is a named refusal the
      // page shows itself; anything else is reported and toasted here.
      const { settled, body } = await settledRefusalOrNull(error);
      if (settled) throw settled;
      await handleError(error, translateOutsideReact('consultantErrors.fallback.failedToCreateManualMatch'), 'createManualMatch', body);
      throw error;
    }

    return data.manualMatch || null;
  }


  /**
   * Delete a manual match
   */
  static async deleteManualMatch(matchId: string): Promise<boolean> {
    try {
      const { data, error } = await supabase.functions.invoke("manual-match-api", {
        method: "POST",
        body: { action: "deleteManualMatch", matchId },
      });

      if (error) throw error;

      return data.success || false;
    } catch (error) {
      await handleError(error, translateOutsideReact('consultantErrors.fallback.failedToDeleteManualMatch'), 'deleteManualMatch');
      throw error;
    }
  }
}
